import sumEnabledRowsInCategory from './helpers/sumEnabledRowsInCategory'

export default (form, baseName) => sumEnabledRowsInCategory(form, `${baseName}.items`)
